import React from "react";
import smalllogo from "../../assets/images/AHA-logo.svg";
export default function Logo() {
  return (
    <div>
      <img className="mb-25" src={smalllogo} alt="AHA logo" />
    </div>
  );
}
